import App from "antd/lib/app";
import { useRouter } from "next/router";
import { ReactNode } from "react";

import { useAuthenticationStore } from "@sol/authentication/useAuthenticationStore";
import { Route } from "@sol/routing";

import { AuthenticatedLayout } from "./AuthenticatedLayout";
import LoginLayout from "./LoginLayout";

type AppLayoutProps = {
    title: string;
    children: ReactNode;
};

export function AppLayout({ children, ...props }: AppLayoutProps) {
    const { token } = useAuthenticationStore();
    const router = useRouter();

    let Layout = token ? AuthenticatedLayout : LoginLayout;

    /* Bypass layout for react-admin pages
     * React-admin uses hash-based routing,
     * so we can directly check for the admin route here
     * sub-paths will be handled by the regular AuthenticatedLayout
     *
     * *Note*: we will migrate everything to nextjs routing in the future
     * and get rid of react-admin */
    if (token && router.pathname === Route.ADMIN) {
        return children;
    }

    if ([Route.COOKIE_POLICY, Route.COOKIE_PREFERENCES].some(route => router.pathname.includes(route))) {
        Layout = LoginLayout;
    }

    return (
        <App>
            <Layout {...props}>{children}</Layout>
        </App>
    );
}
